<template>
  <div class="wai">
    <!-- 查询筛选区 -->
    <div class="curd">
      <div class="sou">
        <el-input v-model="page.orderNo" style="width: 240px;margin-right: 20px;" placeholder="订单号" clearable />
        <el-input v-model="page.name" style="width: 240px;margin-right: 20px;" placeholder="姓名" clearable />
        <el-input v-model="page.cardid" style="width: 240px;margin-right: 20px;" placeholder="身份证号" clearable />
        <el-button round @click="getlist()">查询</el-button>
        <span style="margin-left: 30px;font-weight: bold;color: black;">当前18时前订单：{{page.before}}</span>
        <span style="margin-left: 20px;color: black;">当前剩余总订单：{{page.total}}</span>
      </div>
    </div>

    <div class="zhuyao">
      <!-- 左侧订单列表 -->
      <div class="juese">
        <div class="zhu">
          <div class="biao">
            <el-table
              :row-style="({ row }) => row.orderNo === order?.orderNo ? {'background-color': '#f1fe76'} : {}"
              :data="list"
              style="width: 100%"
            >
              <el-table-column label="订单号">
                <template #default="{row}">
                  <span>{{ row.orderNo }}</span>
                  <el-tag v-if="row.signfile" size="small" type="success" style="margin-left:8px">已CA签发</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80">
                <template #default="{ row }">
                  <el-button type="primary" @click="xuanze(row)" size="small">审核</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              @current-change="getlist"
              :pager-count="4"
              v-model:page-size="page.pageSize"
              v-model:current-page="page.pageno"
              background
              layout="prev, pager, next"
              :total="page.total"
            />
          </div>
        </div>
      </div>

      <!-- 右侧主区域：【上：验签结果】 +【中：PDF预览】，最右边固定侧边业务面板 -->
      <div class="main-right-wrap">
        <div class="pdf‑and‑side">
          <!-- PDF预览区域 -->
          <div class="tu">
            <VueOfficePdf
              v-if="order"
              :key="pdfKey"
              :src="'https://lanxiaoxiao.obs.cn-north-4.myhuaweicloud.com/' + (order.signfile || order.authfile)"
              @error="handleError"
            />
          </div>

          <!-- 右侧固定侧边业务面板：订单信息 + 操作按钮 -->
          <div class="wenzi">
            <div v-if="order" class="info-block">
              <div class="zu">
                <div class="lab">姓名</div>
                <div class="val">{{order.name}}</div>
              </div>
              <div class="zu">
                <div class="lab">身份证</div>
                <div class="val">{{formatIdCard(order.cardid)}}</div>
              </div>
              <div class="zu">
                <div class="lab">提交时间</div>
                <div class="val">{{order.create_time}}</div>
              </div>
              <div class="zu" style="margin-top:12px">
                <div class="lab">CA签章状态</div>
                <div class="val" :class="[order.signfile ? 'text-success' : 'text-warning']">
                  {{ order.signfile ? "✅已CA签发" : caSignLoading ? "签发中" : "未签发" }}
                </div>
              </div>
            </div>

            <div class="shenpi" v-if="order">
              <div class="you">
                <el-button style="width: 100%;height: 40px;" round type="danger" @click="shenhetype = 1">驳回</el-button>
              </div>
              <div class="ca-btn-wrap">
                <el-button
                  style="width: 100%;height: 40px;"
                  round
                  type="info"
                  :loading="caSignLoading"
                  :disabled="!!order.signfile"
                  @click="handleCaSign"
                >
                  CA签发
                </el-button>
              </div>
              <div class="wuzui">
                <el-button style="width: 100%;height: 40px;" round type="success" @click="shenhetype = 2">审核通过</el-button>
              </div>

              <div class="youerci" v-if="shenhetype === 1">
                <el-input v-model="zuizhuang" placeholder="驳回原因" clearable />
                <el-button style="width: 100%;height: 40px;margin-top:14px" round type="danger" @click="youzui()">二次确认驳回</el-button>
              </div>

              <div class="youerci" v-if="shenhetype === 2">
                <el-button
                  style="width: 100%;height: 40px;"
                  round
                  type="success"
                  :disabled="!order.signfile"
                  @click="wuzui()"
                >
                  二次确认审核通过
                </el-button>
                <div v-if="!order.signfile" class="hint-text">请先完成CA签发后再审核通过</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus';
import VueOfficePdf from '@vue-office/pdf'
import { onMounted, reactive, ref, computed } from 'vue';
import { getrisklist, shenpiorder, casSign } from '@/api/api'
import { useLoadingStore } from '../../store/loadingstore'


const loadingStore = useLoadingStore();

onMounted(() => {
  getlist()
})

const order = ref(null)
const zuizhuang = ref('')
const shenhetype = ref(0)
const caSignLoading = ref(false)
const pdfKey = ref(0)

// 验签状态
const verifyLoading = ref(false)
const verifyTip = ref('')
const verifyResult = ref(null)

// 计算属性：过滤只拿不通过的项
const failReportList = computed(() => {
  if (!verifyResult.value || !Array.isArray(verifyResult.value.report)) return []
  return verifyResult.value.report.filter(item => !item.pass)
})

const page = reactive({
  pageno: 1,
  pageSize: 13,
  total: 0,
  orderNo: '',
  name: '',
  cardid: '',
  before: ''
})

const list = ref([])

const getlist = async () => {
  shenhetype.value = 0
  zuizhuang.value = ''
  verifyResult.value = null
  verifyTip.value = ''
  const data = {
    page: page.pageno,
    pageSize: page.pageSize,
    orderNo: page.orderNo,
    name: page.name,
    cardid: page.cardid
  }
  const res = await getrisklist(data)
  if (res.code === 200) {
    list.value = res.data.list || []
    page.pageno = res.data.page
    page.pageSize = res.data.pageSize
    page.total = res.data.total
    page.before = res.data.before
    if (res.data.list?.length) {
      order.value = { ...res.data.list[0] }
      if(order.value.signfile){
        triggerAutoVerify()
      }
    } else {
      order.value = null
    }
  } else {
    ElMessage.error(res.message)
  }
}

const xuanze = (row) => {
  order.value = { ...row }
  shenhetype.value = 0
  zuizhuang.value = ''
  verifyResult.value = null
  verifyTip.value = ''
  if(row.signfile){
    triggerAutoVerify()
  }
}

const formatIdCard = (cardId) => {
  if (!cardId || cardId.length !== 18) {
    return cardId ?? '';
  }
  const parts = [
    cardId.substring(0, 3),
    cardId.substring(3, 6),
    cardId.substring(6, 10),
    cardId.substring(10, 14),
    cardId.substring(14)
  ];
  return parts.join(' ');
};

// CA签发：签发成功自动触发验签
const handleCaSign = async () => {
  if (!order.value?.orderNo) {
    ElMessage.warning('请先选择一条订单');
    return;
  }
  caSignLoading.value = true
  try {
    const res = await casSign({ orderNo: order.value.orderNo })
    if (res.code == 200 && res.subcode == 200001) {
      order.value.signfile = res.data.obsurl
      pdfKey.value++
      ElMessage.success(res.message || "CA签发完成，请审阅签章PDF后审核")
      triggerAutoVerify()
    } else {
      ElMessage.error(res.message || "CA签发失败")
    }
  } catch (err) {
    ElMessage.error("CA签发请求异常，请检查网络或后端服务")
  } finally {
    caSignLoading.value = false
  }
}



const youzui = () => {
  if (!zuizhuang.value?.trim()) {
    ElMessage.error("审核驳回原因不能为空！")
    return
  }
  const data = {
    orderNo: order.value.orderNo,
    state: 0,
    state_tips: zuizhuang.value.trim()
  }
  shenpidingdan(data)
}

const wuzui = () => {
  if (!order.value?.signfile) {
    ElMessage.warning("请先执行CA签发，审阅签章PDF后再审核通过")
    return
  }
  const data = {
    orderNo: order.value.orderNo,
    state: 2,
    state_tips: ''
  }
  shenpidingdan(data)
}

const shenpidingdan = async (data) => {
  loadingStore.show('正在提交审批...');
  try {
    const res = await shenpiorder(data)
    if (res.code === 200) {
      ElMessage.success("审批完成")
      getlist()
    } else {
      ElMessage.error(res.message)
    }
  } catch (e) {
    ElMessage.error('审批提交异常')
  } finally {
    loadingStore.hide();
  }
}

const handleError = () => {
  ElMessage.error("PDF文件加载失败，请检查文件地址")
}
</script>

<style lang="scss" scoped>
.wai {
  width: 100%;
  height: 100%;
  padding: 16px 20px;
  box-sizing: border-box;

  .curd {
    height: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom:16px;
  }

  .zhuyao {
    display: flex;
    gap:16px;
    height: calc(100% - 48px);

    /* 左侧列表 */
    .juese {
      width: 26%;
      height: 100%;

      .zhu {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        border-radius: 10px;
        border:1px solid #eee;

        .biao {
          width: 100%;
          height: calc(100% - 50px);
        }

        .page {
          padding:12px 8px;
          height: 48px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }

    /* 右侧大容器：垂直，上面证书验签，下面pdf+侧边面板 */
    .main-right-wrap {
      flex:1;
      height:100%;
      display:flex;
      flex-direction:column;
      gap:12px;
      overflow-y:auto;

      .verify-wrap{
        flex-shrink:0;
        padding:16px;
        border:1px solid #e8e8e8;
        border-radius:8px;
        background:#fff;

        /* 总览状态提示框 */
        .verify-summary{
          display:flex;
          gap:12px;
          padding:14px 16px;
          border-radius:6px;
          margin-bottom:16px;
          background:#fef0f0;
          &.success{
            background:#f0f9eb;
          }
          .summary-icon{
            font-size:24px;
          }
          .summary-text{
            flex:1;
            .summary-title{
              font-size:16px;
              font-weight:bold;
              margin-bottom:4px;
            }
            .summary-desc{
              font-size:13px;
            }
          }
        }

        .verify-block{
          margin-bottom:18px;
          .block-title{
            font-size:15px;
            font-weight:bold;
            margin-bottom:10px;
            color:#303133;
          }
        }

        /* 失败项样式 */
        .report-item{
          border:1px solid #fbc4c4;
          border-radius:6px;
          padding:10px 12px;
          margin-bottom:8px;
          background:#fef0f0;
          .item-head{
            display:flex;
            gap:8px;
            align-items:center;
            margin-bottom:4px;
            .item-title{
              font-weight:500;
            }
          }
          .item-detail{
            font-size:12px;
            color:#c03838;
            word-break:break-all;
          }
        }

        /* 签名元数据网格布局 */
        .meta-grid{
          display:grid;
          grid-template-columns: 1fr 1fr;
          gap:8px 12px;
          .meta-item{
            font-size:13px;
            .meta-lab{
              color:#909399;
            }
          }
        }

        /* 证书链卡片横向排布 */
        .cert-chain-row{
          display:flex;
          gap:12px;
          flex-wrap:wrap;
        }
        .cert-item{
          border:1px solid #ddd;
          border-radius:6px;
          padding:10px;
          min-width:260px;
          font-size:12px;
          .cert-row{
            margin:4px 0;
            word-break:break-all;
          }
        }
        .disclaimer{
          font-size:11px;
          color:#999;
          margin-top:8px;
        }
      }

      /* pdf + 右侧操作面板 水平布局 */
      .pdf‑and‑side{
        display:flex;
        gap:16px;
        flex:1;
        min-height:0;

        .tu {
          height: 100%;
          overflow-y: auto;
          flex:1;
          border:1px solid #eee;
          border-radius:8px;
        }

        .wenzi {
          width: 320px;
          flex-shrink:0;
          display: flex;
          flex-direction: column;
          gap:18px;

          .info-block{
            padding-bottom:12px;
            border-bottom:1px solid #eee;
          }

          .zu {
            text-align: center;
            margin-bottom:12px;
            .lab {
              font-size: 15px;
              color: #8c8c8c;
              margin-bottom:4px;
            }
            .val {
              font-size: 17px;
              color: #000;
              font-weight: bold;
            }
          }

          .shenpi {
            margin-top: 4px;
            display:flex;
            flex-direction:column;
            gap:12px;

            .youerci{
              margin-top:20px;
            }
            .hint-text{
              color:#f56c6c;
              font-size:12px;
              text-align:center;
              margin-top:6px;
            }
          }
        }
      }
    }
  }
}

.adddig {
  .group {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px 0px;
    .lab {
      padding-left: 20px;
      width: 130px;
    }
  }
}
.text-success{
  color:#67c23a
}
.text-warning{
  color:#e6a23c
}
</style>
